@if (isThinking()) {
  <ng-lottie [options]="options()" width="40px" height="20px"></ng-lottie>
}
